import { render } from "./AddPointModal.vue?vue&type=template&id=1a3b9fee&ts=true"
import script from "./AddPointModal.vue?vue&type=script&lang=ts"
export * from "./AddPointModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__